import { DatabaseZap, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useCheckoutLocale } from "../../lib/useCheckoutLocale";

export const SlowLookupNotice = ({ active, testId }) => {
  const { t } = useCheckoutLocale();
  const [visible,setVisible]=useState(false);
  useEffect(()=>{setVisible(false);if(!active)return undefined;const timer=window.setTimeout(()=>setVisible(true),5000);return()=>window.clearTimeout(timer);},[active]);
  if(!visible)return null;
  return <div className="slow-lookup-notice" role="status" aria-live="polite" data-testid={testId}><span aria-hidden="true"><LoaderCircle className="spin"/><DatabaseZap/></span><p><strong>{t("checkout.slow.title")}</strong> {t("checkout.slow.description")}</p></div>;
};